<template>
  <div class="app-activation-bookable">
    <slot name="txtBefore"></slot>
    <div class="bookable-options">
      <BookableAccordion
        v-for="category in tariffOptionsByCategory"
        :key="category.name"
        :packets="category"
        :fields="tariffOptionFields"
        :selected="category.selected"
        @select="select($event)"
        :expand-multiple="true"
      >
        <template #txtAccordionHeader>{{category.name}}</template>
        <template v-for="slot in possibleChildSlotsFor('BookableAccordion')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </BookableAccordion>
    </div>
    <div class="regular-price">
      <div class="regular-price-label"><slot name="regularPriceLabel"></slot></div>
      <div class="regular-price-value">{{regularPrice()}}</div>
    </div>
    <div class="activation-step">
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button @click="next" :disabled="loading" class="btn-next" type="button" variant="primary">
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </div>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import extraData from '@/mixins/extraData'
import processSteps from '@/mixins/processSteps'
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'
import BookableAccordion from '../../../generic/Tariff/fyve/BookableAccordion.vue'
export const stepName = 'products'

export default {
  name: 'ActivationProducts',
  data () {
    return {
      // smart XS
      loading: false,
      tariffOptionFields: [
        { name: 'tariffOptionName', pos: 1 },
        { name: 'price', pos: 2 },
        { name: 'infoText', pos: 3 }
      ],
      categoryPostions: {
        'Surf-Pakete': 1,
        'Einheiten-Pakete': 2,
        'Spezial-Pakete': 3
      }
    }
  },
  mounted () {
    for (const [, category] of Object.entries(this.tariffOptionsByCategory)) {
      this.storedTariffOptions.forEach(storedOption => {
        const matchedOption = category.items.find(matchedOption => matchedOption.tariffOptionId === storedOption.tariffOptionId)
        if (matchedOption !== undefined) {
          category.selected = matchedOption.tariffOptionId
        }
      })
    }
    this.$forceUpdate()
  },
  components: {
    BookableAccordion
  },
  methods: {
    ...mapActions('activation', [
      'selectProducts'
    ]),
    ...mapMutations('activation', [
      'setPrice'
    ]),
    next () {
      this.loading = true
      this.setPrice(this.price() + this.preactivatedTariff.basicFee)
      this.selectProducts({
        tariff: { tariffId: this.preactivatedTariff.tariffIdentifier },
        tariffOptions: this.selectedOptions(),
        nextStep: this.nextStep
      })
      this.loading = false
    },
    select (event) {
      const oldSelected = this.tariffOptionsByCategory[event.key].selected
      this.tariffOptionsByCategory[event.key].selected = oldSelected !== event.id ? event.id : null
      this.$forceUpdate()
    },
    regularPrice () {
      return (this.price() / 100).toFixed(2).replace('.', ',') + '€'
    },
    price () {
      let price_ = 0
      const selectedOptions = this.selectedOptions()
      selectedOptions.forEach(selectedOption => {
        const fittingOption = this.availableTariffOptions.find(availableOption =>
          availableOption.tariffOptionId === selectedOption.tariffOptionId
        )
        price_ += fittingOption?.price
      })
      return price_
    },
    selectedOptions () {
      const selectedOptions = []
      for (const [, category] of Object.entries(this.tariffOptionsByCategory)) {
        if (category.selected !== null) {
          selectedOptions.push({ tariffOptionId: category.selected })
        }
      }
      return selectedOptions
    }
  },
  mixins: [
    processSteps(stepName, stepName, stepName),
    transaction('bookablePresalesTariffs'),
    slotProxy(),
    extraData()
  ],
  computed: {
    ...mapGetters('activation/info', {
      preactivatedTariff: 'preactivatedTariff',
      tariffOptionsForDisplay: 'tariffOptionsForDisplay',
      availableTariffOptions: 'availableTariffOptions'
    }),
    ...mapGetters('activation/tariffOptions', {
      storedTariffOptions: 'savedTariffOptions'
    }),
    tariffOptionsExtra () {
      const tariffOptions = this.tariffsExtra.filter(item => item.tariffOptionId)
      const tariffOptionsExtra = []
      tariffOptions.forEach(option => {
        tariffOptionsExtra.push({
          tariffOptionId: option.tariffOptionId,
          infoText: option.infoText,
          category: option.category
        })
      })
      return tariffOptionsExtra
    },
    tariffOptionsByCategory () {
      const sortedTariffOptions = []
      this.tariffOptionsExtra.forEach(optionExtra => {
        sortedTariffOptions.push({
          pos: this.categoryPostions[optionExtra.category],
          name: optionExtra.category,
          items: [],
          selected: null
        })
      })
      sortedTariffOptions.sort((a, b) => a.pos - b.pos)
      const mergedTariffOptions = {}
      sortedTariffOptions.forEach(sortedOption => {
        mergedTariffOptions[sortedOption.name] = sortedOption
      })
      this.tariffOptionsForDisplay.forEach(option => {
        const optionExtra = this.tariffOptionsExtra.find(extra => extra.tariffOptionId === option.tariffOptionId)
        const mergedOption = option
        mergedOption.infoText = optionExtra.infoText
        mergedOption.key = optionExtra.category
        mergedTariffOptions[optionExtra.category].items.push(mergedOption)
      })
      for (const [name, category] of Object.entries(mergedTariffOptions)) {
        if (category.items.length === 0) {
          delete mergedTariffOptions[name]
        }
      }
      return mergedTariffOptions
    }
  },
  props: {
    tariffsExtra: {
      type: Array,
      required: true
    }
  }
}
</script>
